import React, { useContext, useEffect } from 'react';
import propTypes from 'prop-types';
import { Modal } from '../Modal';
import { useDialogState } from '../Dialog/useDialogState';
import { QuoteContext } from './QuoteProvider';

const ErrorModal = ({ storeDetails }) => {
  const { loadState, loadingState, setLoadingState } = useContext(QuoteContext);
  const dialogState = useDialogState();
  const { openModal, closeModal } = dialogState;

  useEffect(() => {
    if (loadingState === loadState.ERROR) {
      openModal();
      setLoadingState(loadState.EMPTY);
    }
  }, [loadState, loadingState, setLoadingState, openModal]);

  return (
    <Modal
      title="Error Finalizing Quote"
      id="tooltip--error-message"
      dialogState={dialogState}
    >
      <div className="modal__description">
        <p className="cmp-quote__error-message">
          We ran into a problem trying to finalize your quote. Please try again.
        </p>
        <p>
          <button type="button" className="cmp-button-link cmp-button-link--dark-gray" onClick={closeModal}>
            Return to your quote
          </button>
          {' or call the store at '}
          <a href={`tel:${storeDetails.phone}`} className="cmp-link" aria-label={storeDetails.phoneAccessible}>
            {storeDetails.phoneVisual}
          </a>
          .
        </p>
      </div>
    </Modal>
  );
};

ErrorModal.propTypes = {
  storeDetails: propTypes.shape({
    phone: propTypes.string,
    phoneVisual: propTypes.string,
    phoneAccessible: propTypes.string,
  }),
};

export { ErrorModal };
